import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const styles = {
  root: { textAlign: "center" }
};

class NotFound extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="display4" gutterBottom>
          Fout - 404
        </Typography>
        <Typography variant="body1" gutterBottom>
          Pagina niet gevonden.
        </Typography>
      </div>
    );
  }
}

export default withStyles(styles)(NotFound);



// WEBPACK FOOTER //
// ./src/components/NotFound.js